import { useState } from "react"
import { Button, Collapse, Stack, Typography } from "@mui/material"
import { Bound } from "lib/@components/binding/Bound"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { Repeat } from "lib/@components/repeat"
import { If } from "lib/@components/switch"
import { AuthoringLegislationChangeRow } from "./authoring-legislation-change-row"

export function AuthoringLegislationSelectorDefaultSummary() {
    const { addedCount, removedCount, initialCount, addedNodes, removedNodes, onToggle, getPath, isLoading } =
        useBoundContext()
    const [showChanges, setShowChanges] = useState(false)
    const hasChanges = addedCount + removedCount > 0

    return (
        <Stack spacing={1.5}>
            <Stack direction="row" alignItems="center" spacing={2}>
                <Typography variant="body2" color="text.secondary" data-cy="reference-summary">
                    {summaryText()}
                </Typography>
                <If truthy={!isLoading && hasChanges}>
                    <Button
                        size="small"
                        onClick={() => setShowChanges((current) => !current)}
                        data-cy="review-changes-toggle"
                    >
                        {showChanges ? "Hide" : "Review"} changes
                    </Button>
                </If>
            </Stack>
            <Collapse in={showChanges && hasChanges}>
                <Stack spacing={1.5} sx={{ maxHeight: 160, overflowY: "auto" }} data-cy="reference-changes">
                    <If truthy={addedCount > 0}>
                        <Stack spacing={0.5} data-cy="reference-changes-adding">
                            <Typography variant="caption" color="text.secondary">
                                Adding
                            </Typography>
                            <Bound kind="add" onToggle={onToggle} getPath={getPath}>
                                <Repeat list={addedNodes} keyFn={keyForNode} item={<AuthoringLegislationChangeRow />} />
                            </Bound>
                        </Stack>
                    </If>
                    <If truthy={removedCount > 0}>
                        <Stack spacing={0.5} data-cy="reference-changes-removing">
                            <Typography variant="caption" color="text.secondary">
                                Removing
                            </Typography>
                            <Bound kind="remove" onToggle={onToggle} getPath={getPath}>
                                <Repeat
                                    list={removedNodes}
                                    keyFn={keyForNode}
                                    item={<AuthoringLegislationChangeRow />}
                                />
                            </Bound>
                        </Stack>
                    </If>
                </Stack>
            </Collapse>
        </Stack>
    )

    function summaryText() {
        const parts = [`${initialCount} currently referenced`]
        if (addedCount) parts.push(`${addedCount} to add`)
        if (removedCount) parts.push(`${removedCount} to remove`)
        return parts.join("  ·  ")
    }
}

function keyForNode(node) {
    return node.id
}
